import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/** Without a pet id, matches every pet's discounts: one pet subscribing changes the others'. */
export const petDiscountsQueryKey = (petId?: string) =>
  petId ? ['pet-discounts', petId] : ['pet-discounts']

/** Loads the discounts a new subscription for the pet would take. */
export function useGetPetDiscounts(petId: string) {
  const api = usePortalApi()
  return useQuery({
    queryKey: petDiscountsQueryKey(petId),
    queryFn: async () =>
      dataOrThrow(await api.get('/pets/:id/discounts', { params: { id: petId } })),
  })
}
